import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./Footer.component.scss";

const FooterComponent = () => {
  return (
    <div className="row">
      <div className="col-12 text-center">
        <a
          href="https://wa.me/+541134314566"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FontAwesomeIcon
            className="text-whatsapp mr-4"
            icon={["fab", "whatsapp"]}
            size="2x"
          />
        </a>
        <a
          href="https://www.facebook.com/FormulaQuim"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FontAwesomeIcon
            className="text-facebook mr-4"
            icon={["fab", "facebook"]}
            size="2x"
          />
        </a>
        <a
          href="https://www.instagram.com/formulaquim/?hl=es-la"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FontAwesomeIcon
            className="text-instagram"
            icon={["fab", "instagram"]}
            size="2x"
          />
        </a>
      </div>
    </div>
  );
};

export default FooterComponent;
